var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-md-4 mx-lg-auto",attrs:{"color":"white","width":"250px"}},[_c('v-card-text',[_vm._v(" Adjust screen size to see spacing changes ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }